export default __webpack_public_path__ + "5bfc0dcc0c0ff5a2832ec7d768e3039c.ttf";